import apiFetch from '../../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `ControlSemen/descargarArchivoControlSemen`, method: 'POST', body: values, token: token})
}